export default "__VITE_ASSET__C0xCUbwM__"